import { useMemo } from 'react'

import { Stack, Typography } from '@mui/material'
import { NotificationBody } from './NotificationBody'

interface Props {
  body: string
  subject: string
}

export function EmailBody(props: Props) {
  const { body, subject } = props

  const rows = useMemo(() => body.split('\n'), [body])

  return (
    <Stack direction="column" spacing={0}>
      <Typography variant="subtitle3">{subject}</Typography>
      <NotificationBody rows={rows} />
    </Stack>
  )
}
